import React from "react";
import styled from "styled-components";

const SVG = styled.svg`
  fill: ${(props) => props.$fill};
  height: auto;
  margin-right: 8px;
  width: 16px;
`;

const EditIcon = ({ fill = "black" }) => {
  return (
    <SVG
      $fill={fill}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 637.72 637.72"
    >
      <g>
        <path d="M132.42,526.51c-7.08,0-13.9-2.8-18.92-7.84-5.41-5.41-8.23-12.85-7.79-20.48l6.95-117.69c.39-6.56,3.16-12.73,7.79-17.35L471.17,12.36c5.02-5.02,11.81-7.84,18.92-7.84h0c7.11,0,13.9,2.82,18.92,7.84l110.74,110.74c5.02,5.02,7.84,11.81,7.84,18.92s-2.82,13.9-7.84,18.92l-350.76,350.82c-4.62,4.62-10.79,7.39-17.35,7.79l-117.64,6.92c-.52.02-1.05.05-1.57.05ZM165.48,393.8l-4.57,77.47,77.42-4.55,324.66-324.71-72.9-72.87L165.48,393.8Z" />
        <path d="M538.37,206.71c-3.42,0-6.85-1.31-9.46-3.92l-99.55-99.55c-5.23-5.23-5.23-13.69,0-18.92,5.23-5.23,13.69-5.23,18.92,0l99.55,99.56c5.23,5.23,5.23,13.69,0,18.92-2.61,2.61-6.04,3.92-9.46,3.92Z" />
        <path d="M150.85,417.31c-2.22,0-4.5.1-6.82.31-2.25.24-4.18.94-6.27,1.25l-4.81,81.47,78.18-4.76c.68-2.92,1.41-5.93,1.83-9.04,3.5-39.59-23.73-69.24-62.11-69.24h0Z" />
      </g>
      <path d="M610.96,637.72H26.76c-14.79,0-26.76-11.97-26.76-26.76V26.76C0,11.97,11.97,0,26.76,0h289.88c14.79,0,26.76,11.97,26.76,26.76s-11.97,26.76-26.76,26.76H53.51v530.69h530.69v-263.18c0-14.79,11.97-26.76,26.76-26.76s26.76,11.97,26.76,26.76v289.93c0,14.79-11.97,26.76-26.76,26.76Z" />
    </SVG>
  );
};

export default EditIcon;
